import React from "react";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { usePrecios } from "../hooks/usePrecios";

const euros = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export default function CampamentosVerano() {
  const { precios, error: preciosError } = usePrecios();
  const tarifas = precios?.CampamentoVerano?.tarifas || [];

  return (
    <div id="campamento-verano" className="text-center">
        <Seo
  title="Campamento de verano | Hípica Madrid Campogrande"
  description="Campamentos con caballos, actividades al aire libre y diversión segura. Turnos semanales y plazas limitadas."
  path="/campamento-verano"
  image="https://madridcampogrande.es/og/default.jpg"
/>
<BreadcrumbLd
  items={[
    { name: "Inicio", path: "/" },
    { name: "Campamento verano", path: "/campamento-verano" },
  ]}
/>
      <div className="container">
        {/* Título */}
        <div className="section-title" style={{ marginBottom: 16 }}>
          <h2>Campamentos de Verano</h2>
        </div>

        {/* Introducción */}
        <div className="row" style={{ marginBottom: 24 }}>
          <div className="col-md-10 col-md-offset-1">
            <p style={{ fontSize: 16 }}>
              A niños/as entre <strong>5 y 16 años</strong> que muestren un
              interés especial por los caballos y tengan muchas ganas de vivir
              unos días maravillosos entre caballos y amigos.
            </p>
          </div>
        </div>

        {/* Fotos */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-sm-6">
            <img
              src="/img/portfolio/campamento-verano-1.jpg"
              alt="Campamento Verano 1"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
          <div className="col-sm-6">
            <img
              src="/img/portfolio/campamento-verano-2.jpg"
              alt="Campamento Verano 2"
              style={{
                width: "100%",
                borderRadius: 12,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                marginBottom: 20,
              }}
            />
          </div>
        </div>

        {/* Actividades */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-10 col-md-offset-1">
            <h3>Actividades</h3>
            <h5>Además de juegos de grupo, guerras de agua y algunas otras actividades de ocio, el campamento gira en torno al mundo de los caballos, incluyendo:</h5>
            <ul style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              <li>Clases de equitación (dos horas diarias).</li>
              <li>
                Cuidado del caballo (limpieza, aseo de las cuadras, alimentación,
                etc).
              </li>
              <li>
                Conocimiento de los elementos necesarios para la equitación
                (monturas, cabezadas, etc).
              </li>
              <li>Un día a la semana se podrá ver como trabaja el herrador.</li>
              <li>Paseo en carruaje y conducción del mismo.</li>
              <li>Clases de volteo.</li>
              <li>Clases de doma.</li>
              <li>Clases de salto.</li>
              <li>
                Clases teóricas, todo lo relacionado con el mundo del caballo
                (razas y capas, morfología, características de los caballos,
                etc).
              </li>
              <li>Talleres y juegos entorno a la equitación.</li>
              <li>Paseos por el campo.</li>
            </ul>
          </div>
        </div>

        {/* Medios */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-10 col-md-offset-1">
            <h3>Medios</h3>
            <p style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              La Hípica Madrid Campogrande cuenta con caballos y ponis aptos
              para los niños, siendo la seguridad de los niños el criterio
              decisivo para asignar monturas, pistas y clases a los jinetes.
            </p>
            <p style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              Aunque se recomienda el uso de casco propio (por motivos de higiene
              y comodidad), en el club disponemos de cascos para todos los niños.
            </p>
            <p style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              Monitores experimentados con conocimientos especializados para
              distintas áreas (básico, intermedio, alto, doma, salto, carruajes,
              etc).
            </p>
            <p style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              Zona de recreo arbolada y club social.
            </p>
          </div>
        </div>

        {/* Qué necesito */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-10 col-md-offset-1">
            <h3>¿Qué necesito?</h3>
            <ul style={{ textAlign: "left", maxWidth: 820, margin: "0 auto" }}>
              <li>Casco</li>
              <li>
                Pantalón largo (a ser posible de montar), no recomendamos
                vaqueros.
              </li>
              <li>Calzado deportivo y botas de montar.</li>
              <li>Chaleco protector si se dispone de él (no es obligatorio).</li>
              <li>Es imprescindible traer crema de protección solar.</li>
              <li>Ropa de recambio.</li>
              <li>Pantalón corto, camiseta y gorra.</li>
              <li>
                Es conveniente traer zapatillas, bañador y toalla para las guerras
                de agua.
              </li>
              <li>Se recomienda que los niños lleven pañuelos de papel.</li>
              <li>
                Se deberá aportar fotocopia de la tarjeta sanitaria junto con la
                hoja de inscripción.
              </li>
            </ul>
          </div>
        </div>

        {/* Tabla de precios */}
        <div className="row" style={{ marginBottom: 32 }}>
          <div className="col-md-10 col-md-offset-1">
            <h3>Fechas, horarios y precios</h3>
            {preciosError && (
              <div className="alert alert-warning">
                No se han podido cargar los precios en este momento.
              </div>
            )}
            {!precios && !preciosError && <p>Cargando precios...</p>}
            <table
              className="table table-bordered"
              style={{ maxWidth: 700, margin: "0 auto", background: "#fff" }}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Modalidad</th>
                  <th style={{ textAlign: "center" }}>Detalle</th>
                  <th style={{ textAlign: "center" }}>Precio</th>
                </tr>
              </thead>
              <tbody>
                {tarifas.map((grupo) =>
                  grupo.opciones.map((opcion, index) => (
                    <tr key={`${grupo.modalidad}-${opcion.detalle}`}>
                      {index === 0 && (
                        <td
                          rowSpan={grupo.opciones.length}
                          style={{ verticalAlign: "middle" }}
                        >
                          {grupo.modalidad}
                        </td>
                      )}
                      <td>{opcion.detalle}</td>
                      <td>{euros(opcion.precio)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Observaciones */}
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <p style={{ fontStyle: "italic", opacity: 0.85 }}>
              Las actividades se organizan semanalmente, pudiendo elegir para
              cada niño las semanas que se deseen desde el final del colegio en
              junio hasta el comienzo del mismo en septiembre. Habrá actividades
              de campamento de lunes a viernes no festivos. Los festivos y fines
              de semana el club continuará con sus actividades habituales.
            </p>
            <p style={{ fontStyle: "italic", opacity: 0.85 }}>
              La entrada será a las 09:30 y la salida a las 14:00 para el turno
              de media jornada y las 17:30 para el turno de jornada completa. No
              obstante, si algún niño requiere entrar más temprano y/o salir más
              tarde, nos lo puede indicar y trataremos de cubrir su necesidad.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
